import { Icon, SearchBar, Toast, NoticeBar, Button } from 'antd-mobile';
import React from 'react'
import app from '../../pages/webgl/src/app.js'
import './menu.less'

//树形菜单数据跟库
import TREE from '../../pages/webgl/src/tree.js'
import treeData from '../../pages/webgl/src/treeData.js'

import axios from 'axios'

let page = 1

class Menu extends React.Component {

    state = {
        showResult: false,
        searchData: [],
        showData: [],
        value: '',
        haseMore: false
    }

    componentDidMount() {
        app.menuComponent = this
    }

    //初始化菜单
    init() {
        const tree = new TREE(this.state.treeDom, treeData)
        window.tree = tree
    }

    //搜索框输入变化
    onChange = (value) => {

        this.setState({
            value: value
        })
        let str = value.replace(/^\s+|\s+$/g, "")
        if (str === '') {
            this.setState({
                showResult: false
            })
            return
        }

        this.setState({
            showResult: true
        })

        const _this = this

        Toast.loading()

        let resultArr = []

        this.getResultFn(str, resultArr)

        this.setState({
            searchData: resultArr,
            showData: resultArr.splice(0, 10),
            haseMore: true
        })

        page = 1

        if (resultArr.length < 10) {
            this.setState({
                haseMore: false
            })
        }

        Toast.hide()


    }

    getResultFn(value, resultArr) {
        let sysArr = treeData.root.ch.sub
        searchLoop(sysArr)

        function searchLoop(arr) {
            if (arr.length) {
                arr.forEach(function(child, index) {
                    let name = child["$"]["c"]
                    if (name.indexOf(value) >= 0) {
                        resultArr.push(child)
                    }
                    if (child.ch) {
                        return searchLoop(child.ch.sub)
                    }
                })
            } else {
                let name = arr["$"]["c"]
                if (name.indexOf(value) >= 0) {
                    resultArr.push(arr)
                }
                if (arr.ch) {
                    return searchLoop(arr.ch.sub)
                }
            }
        }

        return resultArr
    }


    onBlur() {
        let valueNow = this.state.value.replace(/^\s+|\s+$/g, "")
        if (valueNow !== '') return
        this.hideResearchResult()
    }

    hideResearchResult() {
        this.setState({
            showResult: false
        })
    }

    onCancel() {
        this.setState({
            value: '',
            showResult: false
        })
    }

    //搜索出來後點擊
    searchClick(item) {
        if (!item) return
        let Group
        //当前点击的是组
        let isGroup
        //当前点击的是组
        if (item.ch && item.ch.sub) {
            isGroup = true
            Group = app.scene.getObjectByName(app.adjustName('Group_' + item.$.o))
            //当前点击的是单个模型的group
        } else {
            Group = app.scene.getObjectByName(app.adjustName(item.$.o))
        }

        if (Group) {

            if (isGroup) {
                app.clickOption(Group)
                app.appendAndrejectGroup(Group, true)
            } else {
                app.lookSearchMesh(Group.dataParent)
                app.clickOption(Group.dataParent)
                app.appendAndrejectGroup(Group.dataParent, true)
            }

        }
    }

    moreClick() {
        page++
        if (this.state.searchData.length <= page * 10) {
            this.setState({
                haseMore: false
            })
        } else {
            this.setState({
                haseMore: true
            })
        }
        this.setState({
            showData: this.state.searchData.splice(0, page * 10)
        })
    }
 

    render() {

        const _this = this

        return (

            <div className = 'menu-wrap-inner'>

              {/*  <div className = 'search-wrap' >
                    <SearchBar
                        ref = { ref => this.autoFocusInst  = ref }
                        value = { this.state.value }
                        onChange= { this.onChange.bind(_this) }
                        onBlur = {this.onBlur.bind(_this)}
                        onCancel= {this.onCancel.bind(_this)} 
                        placeholder = "搜索结构" />

                </div>*/}

                <div className = 'menu-lable'>菜单</div>


                {/*<div onClick = {this.props.toggleMenu.bind(this)} className = 'close-menu-wrap'>
                    <Icon type={'cross'}  size = {'lg'}/>
                </div>
*/}

                <div className = { this.state.showResult?'search-result-wrap':'hide'}>
                    <div className = 'search-result-wrap-inner'>
                        <ul>
                            {
                                this.state.showData&&(this.state.showData.map((item,index) =>(
                                    <li onClick = {this.searchClick.bind(this,item)} key = { index } >
                                        <div >
                                            <p className="jing-name">{item.$.c}</p>
                                            <Icon type="right" size={'sm'} />
                                        </div>
                                    </li>

                                )))
                            }
                            <div  
                                onClick = { this.moreClick.bind(this) }
                                className = {this.state.haseMore?'more-tap':'hide'}>查看更多</div>
                        </ul>

                    </div>
                </div>

                <div className = 'tree-contain-wrap'>
                    <div ref = { el => this.state.treeDom = el } className = { this.state.showResult?'tree-contain hide':'tree-contain'} ></div>
                </div>


            </div>
        )
    }
}

export default Menu


// WEBPACK FOOTER //
// ./src/components/menu/menu.jsx